import { KycProvider, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function getProviderType(kycInfo?: KycResponse | null) {
  return kycInfo?.activeProcess?.provider ?? KycProvider.PROVIDER_UNSPECIFIED;
}
